import { z } from 'zod/v3';
import { InputProcessingEventDetailsSchema } from './InputProcessingEventDetailsSchema';

export const InputProcessingGroupEventDetailsSchema = z.object({
  dataObjectName: z.string().nullable(),
  processingEventDetails: InputProcessingEventDetailsSchema,
});
